import React from 'react'
import StartIcon from "../../assets/star.svg"
import HalfStarIcon from "../../assets/halfStar.svg"
import StartNone from "../../assets/starNone.svg"

const StartRating = ({ stars }) => {
    return (

        stars === 1
            ? <div style={{ display: "flex", gap: "1px" }}>
                <img src={StartIcon} alt='star' />
                <img src={StartNone} alt='star' />
                <img src={StartNone} alt='star' />
                <img src={StartNone} alt='star' />
                <img src={StartNone} alt='star' />
            </div>
            : stars === 1.5
                ? <div style={{ display: "flex", gap: "1px" }}>
                    <img src={StartIcon} alt='star' />
                    <img src={HalfStarIcon} alt='star' />
                    <img src={StartNone} alt='star' />
                    <img src={StartNone} alt='star' />
                    <img src={StartNone} alt='star' />
                </div>
                : stars === 2
                    ? <div style={{ display: "flex", gap: "1px" }}>
                        <img src={StartIcon} alt='star' />
                        <img src={StartIcon} alt='star' />
                        <img src={StartNone} alt='star' />
                        <img src={StartNone} alt='star' />
                        <img src={StartNone} alt='star' />
                    </div> : stars === 2.5
                        ? <div style={{ display: "flex", gap: "1px" }}>
                            <img src={StartIcon} alt='star' />
                            <img src={StartIcon} alt='star' />
                            <img src={HalfStarIcon} alt='star' />
                            <img src={StartNone} alt='star' />
                            <img src={StartNone} alt='star' />
                        </div>
                        : stars === 3
                            ? <div style={{ display: "flex", gap: "1px" }}>
                                <img src={StartIcon} alt='star' />
                                <img src={StartIcon} alt='star' />
                                <img src={StartIcon} alt='star' />
                                <img src={StartNone} alt='star' />
                                <img src={StartNone} alt='star' />
                            </div> : stars === 3.5
                                ? <div style={{ display: "flex", gap: "1px" }}>
                                    <img src={StartIcon} alt='star' />
                                    <img src={StartIcon} alt='star' />
                                    <img src={StartIcon} alt='star' />
                                    <img src={HalfStarIcon} alt='star' />
                                    <img src={StartNone} alt='star' />
                                </div>
                                : stars === 4
                                    ? <div style={{ display: "flex", gap: "1px" }}>
                                        <img src={StartIcon} alt='star' />
                                        <img src={StartIcon} alt='star' />
                                        <img src={StartIcon} alt='star' />
                                        <img src={StartIcon} alt='star' />
                                        <img src={StartNone} alt='star' />
                                    </div> : stars === 4.5
                                        ? <div style={{ display: "flex", gap: "1px" }}>
                                            <img src={StartIcon} alt='star' />
                                            <img src={StartIcon} alt='star' />
                                            <img src={StartIcon} alt='star' />
                                            <img src={StartIcon} alt='star' />
                                            <img src={HalfStarIcon} alt='star' />
                                        </div>
                                        : stars === 5
                                            ? <div style={{ display: "flex", gap: "1px" }}>
                                                <img src={StartIcon} alt='star' />
                                                <img src={StartIcon} alt='star' />
                                                <img src={StartIcon} alt='star' />
                                                <img src={StartIcon} alt='star' />
                                                <img src={StartIcon} alt='star' />
                                            </div> : <div style={{ display: "flex", gap: "1px" }}>
                                                <img src={StartNone} alt='star' />
                                                <img src={StartNone} alt='star' />
                                                <img src={StartNone} alt='star' />
                                                <img src={StartNone} alt='star' />
                                                <img src={StartNone} alt='star' />
                                            </div>




        // <div style={{ display: "flex", gap: "1px" }}>
        //     <img src={StartIcon} alt='star' />
        //     <img src={StartIcon} alt='star' />
        //     <img src={HalfStarIcon} alt='star' />
        //     <img src={StartNone} alt='star' />
        // </div>
    )
}

export default StartRating